export default "__VITE_ASSET__74012adf__"